export default __webpack_public_path__ + "static/media/Group 27092.70ba9748.svg";